import React from 'react';
import { Box, IconButton } from 'theme-ui';
import MuxVideoPlayer from '../MuxPlayer';
import CloseIcon from '~/assets/images/icons/close.svg';

type Props = {
  setPaused: (paused: boolean) => void;
  paused: boolean;
  mainVideo: Queries.muxVideoFragmentFragment | null;
  setMountVideoNode: (mountVideoNode: boolean) => void;
};

const VideoPreview = ({ paused, mainVideo, setPaused, setMountVideoNode }: Props) => {
  const handleVideoEnded = () => {
    setPaused(true);
    setMountVideoNode(false);
  };
  return (
    <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <IconButton
        onClick={handleVideoEnded}
        sx={{
          '--strokecolor': 'white',
          position: 'absolute',
          top: '2.8rem',
          right: '3.5rem',
          zIndex: 7,
          padding: 0,
          cursor: 'pointer',
          display: paused ? 'none' : 'block',
        }}
      >
        <CloseIcon />
      </IconButton>
      <MuxVideoPlayer muxVideo={mainVideo} forceAutoPlay onVideoEnd={handleVideoEnded} preserveAspectRatio />
    </Box>
  );
};

export default VideoPreview;
